import { useBoolean } from '@dreryk/react-common';

import { DiagnosisAdditionalInformationModal } from './DiagnosisAdditionalInformationModal';
import { OnDiagnosisAdditionalInformationChanged } from './DiagnosisAdditionalInformationModal.types';

type DiagnosisAdditionalInformationModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type DiagnosisAdditionalInformationModalOpenerProps = {
   readonly additionalInformation: string | null;
   readonly children: (renderProps: DiagnosisAdditionalInformationModalOpenerRenderProps) => JSX.Element;
   readonly onSuccess: OnDiagnosisAdditionalInformationChanged;
   readonly code: string;
   readonly name: string;
   readonly visitId: number;
};

export const DiagnosisAdditionalInformationModalOpener = (
   props: DiagnosisAdditionalInformationModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   const handleSuccess: OnDiagnosisAdditionalInformationChanged = (additionalInformation) => {
      props.onSuccess(additionalInformation);
      closeModal();
   };

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <DiagnosisAdditionalInformationModal
               additionalInformation={props.additionalInformation}
               code={props.code}
               name={props.name}
               visitId={props.visitId}
               onSuccess={handleSuccess}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
